export default function ViewContactsDialogController(
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;

  function _handleCloseDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.viewContactsDialog);
  }
}

ViewContactsDialogController.$inject = [
  'ssDialogService'
];
